import React, { useEffect, useState } from "react";
import { fetchReportPdf } from "../../../features/queue/taskActions";

// After a Complete on the phone (Mike, 2026-10-09: no auto-print, offer the traveler): the report
// that goes with the parts (its QR leads to the next station's task). It is fetched as soon as the
// task completes, so ONE tap can open the phone's share sheet (Print = AirPrint, Save to Files,
// AirDrop): iPhone only lets a page share inside the tap itself, not after a download. Where files
// can't be shared (a desktop browser in phone preview) the PDF opens in a new tab instead. The
// desktop Job Queue can still reprint it.
export default function TravelerButton({ url, taskId }) {
  const [state, setState] = useState({ status: "loading", file: null, href: null, error: null });
  const [attempt, setAttempt] = useState(0);
  const [shareError, setShareError] = useState(null);

  useEffect(() => {
    let alive = true;
    let href = null;
    setState({ status: "loading", file: null, href: null, error: null });
    fetchReportPdf(url)
      .then((blob) => {
        if (!alive) return;
        href = URL.createObjectURL(blob);
        const file = new File([blob], `traveler-task-${taskId}.pdf`, { type: "application/pdf" });
        setState({ status: "ready", file, href, error: null });
      })
      .catch((err) => {
        if (alive) setState({ status: "failed", file: null, href: null, error: (err && err.message) || "The traveler did not load." });
      });
    return () => {
      alive = false;
      if (href) URL.revokeObjectURL(href);
    };
  }, [url, taskId, attempt]);

  const canShare = Boolean(
    state.file && typeof navigator !== "undefined" && navigator.canShare && navigator.share && navigator.canShare({ files: [state.file] })
  );

  async function share() {
    setShareError(null);
    try {
      await navigator.share({ files: [state.file], title: `Traveler, task ${taskId}` });
    } catch (err) {
      if (!err || err.name !== "AbortError") setShareError("The share sheet didn't open. Use Open traveler instead.");
    }
  }

  return (
    <div className="jq-traveler" data-testid="queue-traveler">
      <div className="fw-semibold">Traveler for the next station</div>
      <div className="jq-muted mb-2">Print it to go with the parts. The desktop queue can reprint it too.</div>
      {state.status === "loading" && (
        <button type="button" className="btn btn-primary btn-lg w-100" disabled>
          <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />Getting the traveler…
        </button>
      )}
      {state.status === "ready" && canShare && (
        <button type="button" className="btn btn-primary btn-lg w-100" onClick={share}>
          <i className="fas fa-share-square me-2" aria-hidden="true" />Print or share traveler
        </button>
      )}
      {state.status === "ready" && (!canShare || shareError) && (
        <a className={`btn btn-lg w-100${canShare ? " btn-outline-primary mt-2" : " btn-primary"}`} href={state.href} target="_blank" rel="noopener noreferrer">
          <i className="fas fa-file-pdf me-2" aria-hidden="true" />Open traveler
        </a>
      )}
      {shareError && <div className="text-danger small mt-1">{shareError}</div>}
      {state.status === "failed" && (
        <>
          <div className="text-danger small mb-2">The traveler didn't load: {state.error}</div>
          <button type="button" className="btn btn-outline-primary btn-lg w-100" onClick={() => setAttempt((a) => a + 1)}>
            Try again
          </button>
        </>
      )}
    </div>
  );
}
